// tslint:disable:no-bitwise
export enum StrategyKind {
  Engine = 0,
  Pocket = 1,
  Menu = 2,
  Disposition = 3,
  Indicator = 4
}
